import AdminClient from '../client/AdminClient';

class HistoricalAumService {
    static async index(session, params) {
        return AdminClient.get(`/v1/admin/investor_historical_aums`, session, {...params,});
    }

    static async new(session) {
        return AdminClient.get(`/v1/admin/investor_historical_aums/new`, session);
    }

    static async create(session, historicalAum) {
        return AdminClient.post(`/v1/admin/investor_historical_aums/`, session, this.parsedHistoricalAum({...historicalAum}));
    }

    static async update(historicalAumId, session, historicalAum) {
        return AdminClient.put(`/v1/admin/investor_historical_aums/${historicalAumId}`, session, this.parsedHistoricalAum({...historicalAum}));
    }

    static async edit(historicalAumId, session) {
        return AdminClient.get(`/v1/admin/investor_historical_aums/${historicalAumId}/edit`, session);
    }

    static async show(historicalAumId, session) {
        return AdminClient.get(`/v1/admin/investor_historical_aums/${historicalAumId}`, session);
    }

    static async delete(historicalAumId, session) {
        return AdminClient.delete(`/v1/admin/investor_historical_aums/${historicalAumId}`, session);
    }

    static async import(session, file) {
        const formData = new FormData();
        formData.append(`investor_historical_aum[file]`, file || '');
        return AdminClient.post(`/v1/admin/investor_historical_aums/import`, session, formData, true);
    }

    static parsedHistoricalAum(historicalAum) {
        return historicalAum;
    }
}
export default HistoricalAumService;